// react-native-blurhash doesn't work with web yet nor do we need it because we don't have placeholders on web already
export default () => {};
